import React from 'react';
import PropTypes from 'prop-types';
import SectionScreenComponent from "./SectionScreenComponent";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";
import {checkChildrenDimensions} from "../../Utils/checkForPercentHeight";
import {useCurrentResolution} from "../../../../Hooks/useCurrentResolution";

const PanelScreenComponent = (props) => {
    const {panel, containerArrayPath, basePath, actionsContext} = props;
    const styles = panel.styles[0];
    const currentResolution = useCurrentResolution();
    let {maximumWidth, maximumHeight} = checkChildrenDimensions(panel.children, currentResolution); //used for set height in to panel in percent from children
    return (
        <div
            id={`screen-panel`}
            style={{
                height: maximumHeight ? maximumHeight : styles.height,
                position: 'relative',
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                width: maximumWidth ? '100%' : 'auto',
                overflow: 'visible'
            }}>
            {(panel.children || []).map((section, index) => {
                return (
                    <SectionScreenComponent
                        key={`${section.type}_${index}`}
                        section={section}
                        containerArrayPath={containerArrayPath}
                        basePath={basePath}
                        actionsContext={actionsContext}
                    />
                )
            })}
        </div>
    );
};
export default JsonScreenHoc(PanelScreenComponent);

PanelScreenComponent.propTypes = {
    panel: PropTypes.object,
    containerArrayPath: PropTypes.string,
    basePath: PropTypes.string,
};